<template>
  <div class="level is-relative">
    <div class="level-left mr-4" v-if="userOpp && isDetail">
      <div class="field">
        <label
          class="has-text-default has-text-weight-bold">
          Créée par:
        </label>
        <div class="control">
          <div class="button no-focus">
            {{ `${userOpp.nom} ${userOpp.prenom}` }}
          </div>
        </div>
      </div>
    </div>
    <div class="level-right mr-4" v-if="!isDetail">
      <div class="level-item">
        <div class="field">
          <label
            class="has-text-default has-text-weight-bold">
            Choisissez un commercial:
          </label>
          <b-autocomplete
            v-model="searchUser"
            :data="users"
            field="name"
            @select="actionSelectUser"
            @typing="getUsers"
            :loading="isFetching" >
            <template slot="empty">
              <div v-if="!isFetching">Aucun résultat</div>
              <div v-else>Rechercher...</div>
            </template>
          </b-autocomplete>
        </div>
      </div>
    </div>
    <div class="level-right" v-if="isAffixe2">
      <div class="level-item">
        <div class="field" v-if="isDetail && agenceSelect">
          <label
            class="has-text-default has-text-weight-bold">
            Agence:
          </label>
          <div class="control">
            <div class="button no-focus">
              {{ agenceSelect.libelleAgence }}
            </div>
          </div>
        </div>
        <b-field
          label="Selectionnez une agence:"
          custom-class="has-text-default has-text-weight-bold mb-0"
          v-else>
          <b-select
            v-model="agenceIdSelect"
            placeholder="Selectionnez une agence:"
            expanded>
            <option
              v-for="agence in agences"
              :key="agence.agenceId"
              :value="agence.agenceId">
              {{ agence.libelleSociete }} - {{ agenceIdUser === agence.agenceId ?
              `${agence.libelleAgence} *` : agence.libelleAgence }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="level-item" v-if="agenceSelect">
        <div class="field">
          <label
            class="has-text-default has-text-weight-bold">
            Société:
          </label>
          <div class="control">
            <button class="button no-focus">
              {{ agenceSelect.libelleSociete }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import * as typesUser from '@/store/modules/user-mutation-type';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import { getUser, getUsers } from '@/api/login';

const User = createNamespacedHelpers('user');
const Parametrages = createNamespacedHelpers('parametrage');
const Panier = createNamespacedHelpers('panier');

export default {
  props: {
    isDetail: Boolean,
    agenceIdOpp: String,
  },
  data() {
    return {
      userOpp: null,
      isFetching: false,
      users: [],
      searchUser: '',
      agences: [],
    };
  },
  computed: {
    ...User.mapGetters({
      agencesCurrentUser: 'agences',
      agenceId: 'agenceId',
      agenceIdUser: 'agenceIdUser',
      currentIdentifiantUser: 'identifiantUser',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    ...Panier.mapGetters({
      userIdentifiantOpp: 'userIdentifiantOpp',
      isModif: 'isModif',
    }),
    agenceIdSelect: {
      get() {
        return this.agenceId;
      },
      set(val) {
        this.setAgenceId(val);
      },
    },
    agenceSelect() {
      if (!this.agences.length || !this.agenceIdSelect) return null;
      const find = this.agences.find(el => el.agenceId === this.agenceIdSelect);
      if (!find) return null;
      return find;
    },
  },
  methods: {
    ...User.mapMutations({
      setAgenceId: typesUser.SET_AGENCE_ID,
    }),
    ...Panier.mapMutations({
      setUserIdentifiantOpp: typesPanier.SET_USER_IDENTIFIANT_OPP,
    }),
    async getUser() {
      this.agences = this.agencesCurrentUser;
      const loadingComponent = this.$buefy.loading.open({ container: this.$el });
      let identifiant = this.currentIdentifiantUser;
      if (this.isModif || this.$route.name === 'detailopportunite') identifiant = this.userIdentifiantOpp;
      if (!identifiant) {
        loadingComponent.close();
        return;
      }
      try {
        if (this.isAffixe2) {
          const res = (await getUsers(identifiant)).data;
          this.userOpp = res.find(user => user.actif);
        } else {
          this.userOpp = (await getUser(identifiant)).data;
        }
        if (this.userOpp) {
          this.agences = this.userOpp.agences;
          this.agenceIdSelect = this.agenceIdOpp || this.userOpp.agenceId;
          this.searchUser = `${this.userOpp.nom} ${this.userOpp.prenom}`;

          this.setUserIdentifiantOpp(
            this.userOpp.email || this.userOpp.identifiant || this.userOpp.id);
        } else this.setUserIdentifiantOpp(null);
        loadingComponent.close();
      } catch (error) {
        this.setUserIdentifiantOpp(null);
        loadingComponent.close();
      }
    },
    getUsers: debounce(async function users() {
      this.users = [];
      if (!this.searchUser) return;
      this.isFetching = true;
      const res = (await getUsers(this.searchUser)).data;
      this.users = res
        .filter(el => (el.email || el.identifiant || el.id) && el.actif)
        .map(el => ({ ...el, name: `${el.nom} ${el.prenom}` }));
      this.isFetching = false;
    }, 500),
    actionSelectUser(option) {
      if (!option) return;
      this.setUserIdentifiantOpp(option.email || option.identifiant || option.id);
      this.agences = option.agences;
      this.agenceIdSelect = option.agenceId;
      this.users = [];
    },
  },
  async mounted() {
    await this.getUser();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/gestionInfoUserOpp.vue